export default __webpack_public_path__ + "static/pm-aa5204db26121638d509560af53b3c37.png";